export default __webpack_public_path__ + "static/media/leftArrow.9b53141c.png";